import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { WindowService } from 'app/shared/window.service';
import { PessoaService } from 'app/shared/pessoa/pessoa.service';
import { CidadesService } from 'app/shared/cidades/cidades.service';
import { CursosService } from 'app/graduacao/cursos/shared/cursos.service';
import { FluxoVestibularService } from 'app/vestibular/inscricao/shared/fluxoVestibular.service';
import { BlockingSpinnerService } from 'app/core/blocking-spinner/blocking-spinner.service';

import { UploadImagemService } from 'app/shared/upload-imagem/upload-imagem.service';
import { Cidade, Estado } from 'models/cidade-estado';
import { Curso } from 'models/curso';
import { DadosVestibular } from 'models/dados-vestibular';
import { environment } from '../../../environments/environment';

import {NgxImageCompressService} from 'ngx-image-compress';
import { Gtag } from 'angular-gtag';

@Component({
  selector: 'dados-pessoais-form',
  templateUrl: './dados-pessoais-form.component.html',
  styleUrls: ['./dados-pessoais-form.component.scss'],
  providers: [CursosService],
})
export class DadosPessoaisFormComponent implements OnInit {

  @Input() showUfCidade = false;
  @Input() showImgUploader = false;
  @Input() showCheckboxTermos = false;
  @Input() showRgOrgexp = false;
  @Input() buscarCpf = false;
  @Input() cpfDisabled = false;
  @Input() useCpd = false;

  @Input() txtBtnSalvar = 'Salvar';
  @Input() txtBtnVoltar = 'Voltar';
  @Input() podeVoltar = false;

  @Input() formData: any = undefined;
  @Input() dadosVestibular: DadosVestibular = undefined;
  @Input() cursosVestibularReingressoInput: any = undefined;
  @Output() onFormSubmit: EventEmitter<any> = new EventEmitter();
  @Output() onVoltar: EventEmitter<any> = new EventEmitter();

  // constantes
  public TIMEOUT_VALIDA_ID_MSECS = 1200;
  public CPF_MASK = [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/];
  public CPD_MASK = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
  public DT_MASK = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
  public RG_MASK = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
  public ORGEXP_MASK = [/([a-zA-Z-/]+)/, /([a-zA-Z-/]+)/, /([a-zA-Z-/]+)/, /([a-zA-Z-/]+)/, /([a-zA-Z-/]+)/, /([a-zA-Z-/]+)/];
  public NUM_INSCRICAO_ENEM = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
  public NOTA_MASK1: any;
  public NOTA_MASK2: any;
  public NOTA_MASK3: any;
  public NOTA_MASK4: any;
  public NOTA_MASK5: any;
  public MSG_CPD_NAO_ENCONTRADO = 'Não encontramos o seu CPD no sistema.';
  public MSG_OPCAO_CURSO_INDISPONIVEL = 'Opção de curso, campus e/ou turno não mais disponível.';
  public MSG_CURSO_NAO_OFERTADO = 'O seu curso não foi ofertado neste vestibular.';

  // vars ctrl
  idLoading: boolean;
  idVerificado: boolean;
  idValido: boolean;
  cadastroExistente: boolean;
  imgValid: boolean;
  btnBlocked = false;
  validarIdTimeout = null;
  linkEdital = '';
  opcoesUf: Estado[] = [];
  opcoesCidades: Cidade[] = [];
  msgErroIdInvalido: string;

  // vars form
  cpf: string;
  cpd: string;
  nome: string;
  rg: string;
  orgexp: string;
  email: string;
  telefone: string;
  celular: string;
  dtNascimento: string;
  uf: any;
  cidade: any;
  aceiteTermos: boolean;
  aceiteLGPD: boolean;
  aceiteTermosDadosPessoais: boolean;
  dataImg: any;
  idVestibular: any;
  dadosCpd: any;
  cursoReingresso: any;
  vinculo: any;
  dadosVest: any;
  isInscrito: any;

  // ENEM Medicina
  anoEnem: any;
  pontuacaoEnemE1: any;
  pontuacaoEnemE2: any;
  pontuacaoEnemE3: any;
  pontuacaoEnemE4: any;
  pontuacaoEnemRE: any;
  anos = [];
  sigla;
  numeroInscricaoEnem: any = '';
  documentoNotas: any = '';
  imagemDocReferencia: any =  '';
  imagemIdentReferencia: any = '';
  documentoVeracidadeInformacao: any = '';
  // documentoConclusaoEnsinoMedio: any = '';
  mediaTotal: any = 0;
  environment = environment;

  imgResultBeforeCompress: string;
  imgResultAfterCompress: string;

  showDocVeraciInfo: boolean = environment.docmentoVeracidadeInfoMedic;

  //Loadscript
  loadApi: Promise<any>;

  public isVestibularEnem;

  constructor(
    private pessoaService: PessoaService,
    private cidadesService: CidadesService,
    private windowService: WindowService,
    private cursosService: CursosService,
    private fluxoVestibularService: FluxoVestibularService,
    private uploadImagemService: UploadImagemService,
    private blockingSpinnerService: BlockingSpinnerService,
    private imageCompress: NgxImageCompressService,
    private gtag: Gtag
  ) { }


  ngOnInit() {
    this.gtag.event('button-convertion');

    this.dadosVest = this.fluxoVestibularService.getDadosVestibular();
    this.sigla = this.fluxoVestibularService.getDadosVestibular().vestibular.sigla;
    // console.log(this.dadosVestibular);
    this.linkEdital = this.windowService.nativeWindow.location.origin + '/vestibular/editais-manuais';
    this.initVars();

    if (this.showUfCidade) {
      this.cidadesService.getEstados().then(estados => {
        this.opcoesUf = estados;
      });
    }

    if (this.formData && this.formData.cpf) {
      Object.assign(this, this.formData);
      if (this.buscarCpf) {
        this.validaCpf(true);
      } else {
        if (this.showUfCidade) {
          this.onChangeUf(() => { this.cidade = this.formData.cidade; });
        }
        this.idVerificado = true;
        this.idValido = true;
      }
    }
    //ENEM Medicina
    const anoHoje = new Date().getFullYear();
    this.anos = [anoHoje - 1, anoHoje - 2, anoHoje - 3, anoHoje - 4, anoHoje - 5];
  }

  initVars() {
    this.idLoading = false;
    this.idVerificado = false;
    this.idValido = false;
    this.cadastroExistente = false;
    this.nome = '';
    if (this.useCpd) {
      this.cpf = '';
    }
    this.email = '';
    this.telefone = '';
    this.celular = '';
    this.dtNascimento = '';
    this.uf = '';
    this.cidade = '';
    this.aceiteTermos = false;
    this.aceiteLGPD = false;
    this.dataImg = { clean: true };
    this.dadosCpd = undefined;
    this.msgErroIdInvalido = undefined;
    this.rg = '';
    this.orgexp = '';
    this.vinculo = null;
  }

  validaCpf(now = false) {
    const milisecs = now ? 1 : this.TIMEOUT_VALIDA_ID_MSECS;

    if (this.validarIdTimeout !== null) {
      clearTimeout(this.validarIdTimeout);
    }

    // limpa variaveis de controle
    this.initVars();

    this.validarIdTimeout = setTimeout(() => {

      const thisTimeout = this.validarIdTimeout;
      if (!this.cpf || this.cpf.length === 0) {
        return;
      }

      this.idValido = this.pessoaService.validarCpf(this.cpf);

      if (!this.idValido) {
        this.idVerificado = true;
        return;
      }

      this.idLoading = true;

      // verificar se o cpf possui cadastro
      this.pessoaService.buscarPessoa(this.cpf, this.dadosVest.vestibular.ano.toString(), this.dadosVest.vestibular.codigo.toString()).then(
        pessoa => {
          //console.log(pessoa);
          if (thisTimeout !== this.validarIdTimeout) {
            return;
          }

          if (!pessoa || !pessoa.nome) {
            this.vinculo = pessoa.vinculo;
            this.cadastroExistente = false;
          } else {
            this.nome = pessoa.nome;
            this.dtNascimento = pessoa.dtNascimento;
            this.email = pessoa.email ? pessoa.email.toLowerCase() : '';
            this.telefone = pessoa.ddd + pessoa.celular;
            this.cadastroExistente = true;
            if (pessoa.uf) {
              this.uf = pessoa.uf;
              this.onChangeUf(() => { this.cidade = pessoa.cidade; });
            }
            this.rg = pessoa.rg;
            this.orgexp = pessoa.orgexp;
            this.vinculo = pessoa.vinculo;
            if (this.orgexp) {
              this.sanitizaOrgexp();
            }
          }
          this.isInscrito = pessoa.isInscrito;
          //console.log(this.isInscrito);

          this.idLoading = false;
          this.idVerificado = true;
        });

    }, milisecs);

  }

  validaCpd(now = false) {
    const milisecs = now ? 1 : this.TIMEOUT_VALIDA_ID_MSECS;

    if (this.validarIdTimeout !== null) {
      clearTimeout(this.validarIdTimeout);
    }

    // limpa variaveis de controle
    this.initVars();

    this.validarIdTimeout = setTimeout(() => {

      const thisTimeout = this.validarIdTimeout;
      if (!this.cpd || this.cpd.length === 0) {
        return;
      }

      this.idValido = this.pessoaService.validarCpd(this.cpd);
      if (!this.idValido) {
        this.idVerificado = true;
        return;
      }

      this.idLoading = true;

      // verificar se o cpd possui cadastro
      this.pessoaService.buscarPessoaPeloCpd(this.cpd).then(
        pessoa => {
          if (thisTimeout !== this.validarIdTimeout) {
            return;
          }

          if (!pessoa) {
            this.cadastroExistente = false;
          } else {
            this.nome = pessoa.nome;
            this.cpf = pessoa.cpf;
            this.dtNascimento = pessoa.dtNascimento;
            this.email = pessoa.email ? pessoa.email.toLowerCase() : '';
            this.telefone = pessoa.ddd + pessoa.celular;
            this.dadosCpd = pessoa.dadosCpd;
            this.cadastroExistente = true;
          }

          // verifica oferta do curso
          const cursoOfertado = this.dadosVestibular.vestibular.cursosOfertados
            .filter(curso => curso.codCurso === this.dadosCpd.curso)
            .length > 0;
          if (!cursoOfertado) {
            this.idValido = false;
            this.msgErroIdInvalido = this.MSG_CURSO_NAO_OFERTADO;
          } else {
            this.validarOpcaoCurso();
          }

          this.idLoading = false;
          this.idVerificado = true;
        },

        errResp => {
          // tratar mensagem de CPD não encontrado e CPD inapto para reingresso
          this.msgErroIdInvalido = this.MSG_CPD_NAO_ENCONTRADO;
          if (errResp.error && errResp.error.mensagem) {
            this.msgErroIdInvalido = errResp.error.mensagem;
          }
          this.idValido = false;
          this.idVerificado = true;
          this.idLoading = false;
        },
      );

    }, milisecs);

  }

  private async validarOpcaoCurso() {
    let existeOpcao = false;
    const cursoReingressoCpd: Curso[] = await this.cursosService.getCurso(this.dadosCpd.curso);
    this.cursosVestibularReingressoInput.forEach((opCurso) => {
      if (opCurso.id === this.dadosCpd.curso) {
        opCurso.campi.forEach(opCampi => {
          if (opCampi.id === this.dadosCpd.campus) {
            //console.log(opCampi);
            opCampi.turnos.forEach((opTurno) => {
              if (opTurno.turno === this.dadosCpd.turno) {
                existeOpcao = true;
                this.cursoReingresso = {
                  curso: cursoReingressoCpd[0] || opCurso,
                  campusTurno: opCampi,
                  investimento: cursoReingressoCpd[0] ? this.calcValorFinal(cursoReingressoCpd[0], opCampi) : 0.00,
                };
                if (!cursoReingressoCpd[0]) {
                  this.criaCursoInfoServico(opCurso);
                }
                this.cursoReingresso.campusTurno.turno = this.dadosCpd.turno;
              }
            });
          }
        });
      }
    });

    if (!existeOpcao) {
      this.idValido = false;
      this.msgErroIdInvalido = this.MSG_OPCAO_CURSO_INDISPONIVEL;
    }
  }

  criaCursoInfoServico(opCurso) {
    const turnosUnicos = opCurso.campi
      .map((campiMap) => campiMap.turnos)
      .flat()
      .filter((item, pos, array) => array.indexOf(item) === pos);
    this.cursoReingresso.curso = {
      id: opCurso.id,
      nome: opCurso.nome,
      campi: opCurso.campi,
      areaConhecimento: 'Área de conhecimento não informada',
      formacao: 'Formação não informada',
      turnos: turnosUnicos,
      duracao: 0.00,
      valorBase: 0.00,
      investimento: 0.00,
      portaria: 'Portaria não informada',
      presencial: '-',
    };
    this.cursoReingresso.campus = opCurso.campi;
  }

  enableSalvar(): boolean {
    if(this.sigla=='MN'){
      //Caso o vestibular seja de Medicina ENEM
      // Cálculo da nota final
      // Precisamos das médias de área de conhecimento
      let mediaNotaAreasConhecimento = (parseFloat(this.pontuacaoEnemE1)+
                                       parseFloat(this.pontuacaoEnemE2)+
                                       parseFloat(this.pontuacaoEnemE3)+
                                       parseFloat(this.pontuacaoEnemE4))/4;
      // A média das áreas de conhecimento é então somada com a nota do ENEM e /2
      let media = (mediaNotaAreasConhecimento+parseFloat(this.pontuacaoEnemRE))/2;
      this.mediaTotal = parseFloat(media.toString()).toFixed(2);
      // Por fim verifica o valor dessa média
      // Se for menor que 650, o candidato não pode passar
      //console.log(this.mediaTotal);
      if(this.mediaTotal<450 || this.mediaTotal>1000) return false;


      let pontuacaoMinima=0.000;
      let pontuacaoMaxima=1000.000;
      if(!this.pontuacaoEnemE1 || parseFloat(this.pontuacaoEnemE1)>pontuacaoMaxima || parseFloat(this.pontuacaoEnemE1)<=pontuacaoMinima)return false;
      if(!this.pontuacaoEnemE2 || parseFloat(this.pontuacaoEnemE2)>pontuacaoMaxima || parseFloat(this.pontuacaoEnemE2)<=pontuacaoMinima)return false;
      if(!this.pontuacaoEnemE3 || parseFloat(this.pontuacaoEnemE3)>pontuacaoMaxima || parseFloat(this.pontuacaoEnemE3)<=pontuacaoMinima)return false;
      if(!this.pontuacaoEnemE4 || parseFloat(this.pontuacaoEnemE4)>pontuacaoMaxima || parseFloat(this.pontuacaoEnemE4)<=pontuacaoMinima)return false;
      if(!this.pontuacaoEnemRE || parseFloat(this.pontuacaoEnemRE)>pontuacaoMaxima || parseFloat(this.pontuacaoEnemRE)<=pontuacaoMinima)return false;


      /**
       * Imagens e documentos
       */
      if((!this.documentoNotas)||(this.documentoNotas==='')) return false;
      if((!this.imagemDocReferencia)||(this.imagemDocReferencia==='')) return false;
      if((!this.imagemIdentReferencia)||(this.imagemIdentReferencia==='')) return false;
      if((!this.documentoVeracidadeInformacao)||(this.documentoVeracidadeInformacao==='')) return false;
      // if((!this.documentoConclusaoEnsinoMedio) || (this.documentoConclusaoEnsinoMedio==='')) return false;
      if(!this.anoEnem)return false;
      if((!this.aceiteTermosDadosPessoais) && this.showDocVeraciInfo == true)return false;
      if(!(this.numeroInscricaoEnem>0)) return false;
    }

    if((!this.aceiteLGPD) && this.showDocVeraciInfo){
      return false;
    }

    if (this.btnBlocked) {
      return false;
    }

    if (!this.idVerificado || !this.idValido) {
      return false;
    }

    if (!this.isNomeValido()) {
      return false;
    }

    if (!this.isDtNascimentoValida()) {
      return false;
    }

    if (!this.isEmailValido()) {
      return false;
    }

    if (!this.isTelefoneValido()) {
      return false;
    }

    //console.log(this.isCelularValido());

    if (!this.isCelularValido()) {
      return false;
    }

    if (this.showUfCidade && (!this.uf || !this.cidade)) {
      return false;
    }

    if ((this.showImgUploader && (!this.dataImg || this.dataImg.clean)) &&
         this.sigla!='MN') {
           // console.log('teste');
      return false;
    }

    if (this.showCheckboxTermos && !this.aceiteTermos) {
      return false;
    }

    if(!this.isVestibularEnem){
      return false;
    }

    return true;
  }

  selecionarAnoEnem(e) {
    this.anoEnem = e.target.value;
    console.log('ano selecionado: ', this.anoEnem);
  }

  validarNota1(event) {
    const numHundread = event.target.value.substring(0, 3);
    const notaMax = 1000;
    if (event.keyCode == '8') {
      this.pontuacaoEnemE1 = '';
    }
    if (numHundread * 10 > notaMax) {
      this.NOTA_MASK1 = [/[1-9]/, /\d/, /\d/, '.', /\d/, /\d/, /\d/];
    } else {
      this.NOTA_MASK1 = [/[1-9]/, /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/]; // 1000.000
      if (this.pontuacaoEnemE1 > notaMax) {
        this.pontuacaoEnemE1 = 1000.000;
      }
    }
  }

  validarNota2(event) {
    const numHundread = event.target.value.substring(0, 3);
    const notaMax = 1000;
    if (event.keyCode == '8') {
      this.pontuacaoEnemE2 = '';
    }
    if (numHundread * 10 > notaMax) {
      this.NOTA_MASK2 = [/[1-9]/, /\d/, /\d/, '.', /\d/, /\d/, /\d/];
    } else {
      this.NOTA_MASK2 = [/[1-9]/, /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/];
      if (this.pontuacaoEnemE2 > notaMax) {
        this.pontuacaoEnemE2 = 1000.000;
      }
    }
  }

  validarNota3(event) {
    const numHundread = event.target.value.substring(0, 3);
    const notaMax = 1000;
    if (event.keyCode == '8') {
      this.pontuacaoEnemE3 = '';
    }
    if (numHundread * 10 > notaMax) {
      this.NOTA_MASK3 = [/[1-9]/, /\d/, /\d/, '.', /\d/, /\d/, /\d/];
    } else {
      this.NOTA_MASK3 = [/[1-9]/, /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/];
      if (this.pontuacaoEnemE3 > notaMax) {
        this.pontuacaoEnemE3 = 1000.000;
      }
    }
  }

  validarNota4(event) {
    const numHundread = event.target.value.substring(0, 3);
    const notaMax = 1000;
    if (event.keyCode == '8') {
      this.pontuacaoEnemE4 = '';
    }
    if (numHundread * 10 > notaMax) {
      this.NOTA_MASK4 = [/[1-9]/, /\d/, /\d/, '.', /\d/, /\d/, /\d/];
    } else {
      this.NOTA_MASK4 = [/[1-9]/, /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/];
      if (this.pontuacaoEnemE4 > notaMax) {
        this.pontuacaoEnemE4 = 1000.000;
      }
    }
  }

  validarNota5(event) {
    //console.log(event)
    const numHundread = event.target.value.substring(0, 3);
    const notaMax = 1000;
    if (event.keyCode == '8') {
      this.pontuacaoEnemRE = '';
    }
    if (numHundread * 10 > notaMax) {
      this.NOTA_MASK5 = [/[1-9]/, /\d/, /\d/, '.', /\d/, /\d/, /\d/];
    } else {
      this.NOTA_MASK5 = [/[1-9]/, /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/];
      if (this.pontuacaoEnemRE > notaMax) {
        this.pontuacaoEnemRE = 1000.000;
      }
    }
  }

  salvar() {
    // console.log(this.documentoNotas);
    // avoid multiple clicks
    this.btnBlocked = true;
    setTimeout(() => {
      this.btnBlocked = false;
    }, 2000);

    const dadosPessoais = {
      cpf: this.cpf,
      nome: this.nome,
      email: this.email,
      dtNascimento: this.dtNascimento,
      telefone: this.telefone,
      cadastroExistente: this.cadastroExistente,
    };

    if (this.vinculo) {
      Object.assign(dadosPessoais, {
        vinculo: this.vinculo,
      });
    }

    if (this.useCpd) {
      Object.assign(dadosPessoais, {
        cpd: this.cpd,
        dadosCpd: this.dadosCpd,
        cursoReingresso: this.cursoReingresso,
      });
    }

    if (this.showUfCidade) {
      Object.assign(dadosPessoais, {
        uf: this.uf,
        cidade: this.cidade,
      });
    }

    if (this.showImgUploader) {
      Object.assign(dadosPessoais, {
        dataImg: this.dataImg,
      });
    }

    if (this.showCheckboxTermos) {
      Object.assign(dadosPessoais, {
        aceiteTermos: this.aceiteTermos,
      });
    }

    if (this.showRgOrgexp) {
      Object.assign(dadosPessoais, {
        rg: this.rg,
        orgexp: this.orgexp,
      });
    }
    //console.log(this.celular);
    if (this.celular) {
      Object.assign(dadosPessoais, {
        celular: this.celular,
      });
    }

    if (this.sigla == 'MN'){
      // Vestibular de Medicina ENEM
      if (this.anoEnem) {
        Object.assign(dadosPessoais, {
          ano: this.anoEnem,
        });
      }
      if(this.pontuacaoEnemE1){
        Object.assign(dadosPessoais, {
          pontuacaoEnemE1: this.pontuacaoEnemE1,
        })
      }
      if(this.pontuacaoEnemE2){
        Object.assign(dadosPessoais, {
          pontuacaoEnemE2:this.pontuacaoEnemE2
        })
      }
      if(this.pontuacaoEnemE3){
        Object.assign(dadosPessoais, {
          pontuacaoEnemE3:this.pontuacaoEnemE3
        })
      }
      if(this.pontuacaoEnemE4){
        Object.assign(dadosPessoais, {
          pontuacaoEnemE4:this.pontuacaoEnemE4
        })
      }
      if(this.pontuacaoEnemRE){
        Object.assign(dadosPessoais, {
          pontuacaoEnemRE:this.pontuacaoEnemRE
        })
      }
      if(this.numeroInscricaoEnem){
        Object.assign(dadosPessoais, {
          numeroInscricaoEnem: this.numeroInscricaoEnem
        })
      }
      if(this.documentoNotas){
        Object.assign(dadosPessoais, {
          documentoNotas:this.documentoNotas
        })
      }
      if(this.imagemDocReferencia){
        Object.assign(dadosPessoais, {
          imagemDocReferencia:this.imagemDocReferencia
        })
      }
      if(this.imagemIdentReferencia){
        Object.assign(dadosPessoais, {
          imagemIdentReferencia:this.imagemIdentReferencia
        })
      }
      if(this.documentoVeracidadeInformacao){
        Object.assign(dadosPessoais, {
          documentoVeracidadeInformacao:this.documentoVeracidadeInformacao
        })
      }
      // if(this.documentoConclusaoEnsinoMedio){
      //   Object.assign(dadosPessoais, {
      //     documentoConclusaoEnsinoMedio:this.documentoConclusaoEnsinoMedio
      //   })
      // }
    }
    // console.log(dadosPessoais);
    this.onFormSubmit.emit(dadosPessoais);

  }

  voltar() {
    this.onVoltar.emit(true);
  }

  /*******************
   *** AUX METHODS ***
   *******************/

  isDtNascimentoValida() {
    if (!this.dtNascimento || this.dtNascimento.length < 10) {
      return false;
    }

    try {
      const dateParts = this.dtNascimento.split('/');
      const dia = parseInt(dateParts[0], 10);
      const mes = parseInt(dateParts[1], 10);
      const ano = parseInt(dateParts[2], 10);
      const date = new Date(ano, mes - 1, dia);

      if (date.getFullYear() === ano
        && date.getMonth() + 1 === mes
        && date.getDate() === dia) {

        if (date > new Date()) {
          return false;
        }
        return true;
      }
    } catch (error) {
      // para pegar datas vazias ou nao completas, daria erro no split
      // quer dizer q nao é valida
    }
    return false;
  }

  isEmailValido() {
    const emailUser = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@/;
    const emailProvider = /(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
    const regex = new RegExp([emailUser, emailProvider].map(r => r.source).join(''));

    if (regex.test(this.email)) {
      return true;
    }
    return false;
  }

  isNomeValido() {
    if (!this.nome || this.nome.length < 5) {
      return false;
    }
    let qtde = 0;
    const pieces = this.nome.trim().split(' ');
    pieces.forEach(piece => {
      if (piece.length >= 2) {
        qtde++;
      }
    });
    if (qtde < 2) {
      return false;
    }
    return true;
  }

  isTelefoneValido() {
    const tel = this.telefone.replace(/[^\d]+/g, '');
    if (!tel || tel.length < 10) {
      return false;
    }
    return true;
  }

  isCelularValido(){
    const tel = this.celular.replace(/[^\d]+/g, '');
    if (!tel || tel.length < 10) {
      return false;
    }
    return true;
  }

  sanitizaOrgexp() {
    this.orgexp = this.orgexp.replace(/[^a-zA-Z-/]+/g, '').split('').slice(0, 6).join('');
  }

  onChangeUf(callback?: Function) {
    this.cidade = '';
    this.opcoesCidades = [];
    if (this.uf && this.uf.sigla) {
      this.cidadesService.getCidades(this.uf.sigla).then(cidades => {
        this.opcoesCidades = cidades;
        if (callback) {
          callback();
        }
      });
    }
  }

  compareObjetoUfs(uf1, uf2) {
    return uf1 && uf2 && uf1.sigla === uf2.sigla;
  }

  compareObjetoCidades(cidade1, cidade2) {
    return cidade1 && cidade2 && cidade1.id === cidade2.id;
  }

  telefoneMask(rawValue) {
    if (rawValue) {
      const tel = rawValue.replace(/[^\d]+/g, '');

      // novos telefones com o nono dígito
      if (tel && tel.length > 10) {
        return ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
      }
    }

    return ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  }

  onImageSelected(dataImg) {
    this.dataImg = dataImg;
  }

  async compress(image){
    let img;
    //console.log('Size in bytes was: ', this.imageCompress.byteCount(image.image));
    await this.imageCompress.compressFile(image.image, null, 70, 70).then((result) => {
      img = result;
      //console.log('Size in byte after compress: ', this.imageCompress.byteCount(this.imgResultAfterCompress));
    });
    //console.log(img);
    return img;
  }

  // Vestibular Medicina ENEM
  async onDocumentSelected(image){
    //console.log(img);
    //console.log(document);
    //Documento inserido separadamente
    this.blockingSpinnerService.show();
    let img = await this.compress(image);
    this.uploadImagemService.uploadImagem(
      this.dadosVest.vestibular.ano,
      this.dadosVest.vestibular.codigo,
      this.cpf.replace(/[^\d]+/g, ''),
      null,
      //Vestibular ENEM Medicina
      img,
      null,
      null,
      null
    ).then(()=>{
      //console.log('deu ruim');
      this.documentoNotas = document;
      this.blockingSpinnerService.close();
    })
    .catch((err)=>{
      this.documentoNotas = false;
      this.blockingSpinnerService.close();
    })

  }

  // Imagem 3x4
  async onImageDocRefSelected(image) {
    this.blockingSpinnerService.show();
    let img = await this.compress(image);
    this.uploadImagemService.uploadImagem(
      this.dadosVest.vestibular.ano,
      this.dadosVest.vestibular.codigo,
      this.cpf.replace(/[^\d]+/g, ''),
      null,
      // Vestibular ENEM Medicina
      null,
      img,
      null,
      null,
    ).then(() => {
      this.imagemDocReferencia = image.image;
      this.blockingSpinnerService.close();
    })
    .catch(() => {
      this.imagemDocReferencia = false;
      this.blockingSpinnerService.close();
    });
  }

  async onImageIdentRef(image){
    this.blockingSpinnerService.show();
    let img = await this.compress(image);
    this.uploadImagemService.uploadImagem(
      this.dadosVest.vestibular.ano,
      this.dadosVest.vestibular.codigo,
      this.cpf.replace(/[^\d]+/g, ''),
      null,
      //Vestibular ENEM Medicina
      null,
      null,
      img,
      null
    ).then(()=>{
      this.imagemIdentReferencia = image.image;
      this.blockingSpinnerService.close();
    })
    .catch(()=>{
      this.imagemIdentReferencia = false;
      this.blockingSpinnerService.close();
    })
  }

  async onDocumentInfoRef(image){
    this.blockingSpinnerService.show();
    let img = await this.compress(image);
    this.uploadImagemService.uploadImagem(
      this.dadosVest.vestibular.ano,
      this.dadosVest.vestibular.codigo,
      this.cpf.replace(/[^\d]+/g, ''),
      null,
      // Vestibular ENEM Medicina
      null,
      null,
      null,
      img,
    ).then(()=>{
      this.blockingSpinnerService.close();
      this.documentoVeracidadeInformacao = image.image;
    })
    .catch((err)=>{
      this.blockingSpinnerService.close();
      this.documentoVeracidadeInformacao = false;
    })
  }

  // async onDocumentConclusionDeclaration(image){
  //   this.blockingSpinnerService.show();
  //   let img = await this.compress(image);
  //   this.uploadImagemService.uploadImagem(
  //     this.dadosVest.vestibular.ano,
  //     this.dadosVest.vestibular.codigo,
  //     this.cpf.replace(/[^\d]+/g, ''),
  //     null,
  //     // Vestibular ENEM Medicina
  //     null,
  //     null,
  //     null,
  //     img,
  //   ).then(()=>{
  //     this.blockingSpinnerService.close();
  //     this.documentoConclusaoEnsinoMedio = image.image;
  //   })
  //   .catch((err)=>{
  //     this.blockingSpinnerService.close();
  //     this.documentoConclusaoEnsinoMedio = false;
  //   })
  // }

  // ** Vestibular Medicina ENEM **

  private calcValorFinal(curso, campusTurno): number {
    let preco = curso.valorBase;
    if (campusTurno.desconto) {
      preco *= (1 - (campusTurno.desconto / 100));
    }
    return preco;
  }


  public disableProxButton(event){
    console.log(event);
  }
}
